// 定義需要通知的影片分類
export const NOTIFICATION_CATEGORIES = ['new', 'update'];

// 創建一個自定義事件
export const NEW_VIDEO_UPDATED_EVENT = 'cache:app:facility:notifiedNewestVideoTime:updated';
